<template>
  <div>
    <vs-navbar v-if="!hide" not-line center-collapsed :padding-scroll="scrollPadding" v-model="internalActive" :class="{ 'transparent-bg': transparent || transparentOnTop, 'transparent-on-top': transparentOnTop }">
      <template #left>
        <vs-navbar-item to="/watch" target="_self" :active="active === 'watch'" id="watch">{{ $t("navbar.watch_option") }}</vs-navbar-item>
        <vs-navbar-item to="/lectorem" target="_top" :active="active === 'lectorem'" id="lectorem">{{ $t("navbar.read_option") }}</vs-navbar-item>
      </template>

      <div v-if="active === 'lectorem'">
        <router-link to="/lectorem">
          <img src="../assets/lectorem_black.svg" alt="" height="47" class="hideWhenSmall" style="width: 200px; object-fit: contain">
        </router-link>
      </div>
      <div v-else>
        <router-link to="/">
          <VidentiIcon height="47" class="videntiIcon hideWhenSmall" style="width: 200px; object-fit: contain"></VidentiIcon>
        </router-link>
      </div>

      <template #right>
        <vs-button icon animation-type="scale" primary @click="openSearchPopup" v-if="searchButton">
          <i class='bx bx-search-alt-2'></i>
          <template #animate>
            <i class='bx bx-search-alt-2'></i>
          </template>
        </vs-button>
        <div class="hideWhenSmall">
          <vs-navbar-group v-if="!isLoggedIn">
            <vs-avatar size="40" @click="popup.login.active = true" v-if="!isLoggedIn">
              <i class="bx bxs-user"></i>
            </vs-avatar>

            <template #items>
              <vs-navbar-item @click="popup.login.active = true">
                <i class="bx bx-log-in-circle"></i> Iniciar sesión
              </vs-navbar-item>
            </template>
          </vs-navbar-group>
        </div>
        <div class="showWhenSmall">
          <!-- <vs-button animation-type="vertical" color="discord" href="https://api.videnti.co/discord/login">
            <i class='bx bxs-log-in-circle bx-sm'></i>
            <template #animate >
              <i class='bx bxl-discord bx-sm'></i>
            </template>
          </vs-button> -->
          <vs-button primary @click="popup.login.active = true" v-if="!isLoggedIn">
            <i class='bx bxs-log-in-circle bx-sm'></i>
          </vs-button>
        </div>

        <vs-navbar-group v-if="isLoggedIn">
          <vs-avatar size="40" v-if="isLoggedIn">
            <img :src="avatarURL" alt="">
            <!-- <b style="margin-left: 10px;">{{ $store.state.auth.username }}</b> -->
          </vs-avatar>

          <template #items>
            <vs-navbar-item aria-disabled="true" disabled="true" style="cursor: initial !important;">
              {{ username }}
            </vs-navbar-item>
            <hr>
            <vs-navbar-item to="/my/account" target="_top" :active="active === 'myaccount'" id="myaccount">
              <i class="bx bxs-user-account"></i> | Mi cuenta
            </vs-navbar-item>
            <vs-navbar-item to="/my/favorites" target="_top" :active="active === 'liked'" id="liked">
              <i class="bx bxs-heart"></i> | {{ $t("navbar.my_likes") }}
            </vs-navbar-item>
            <vs-navbar-item to="/my/watchlist" target="_top" :active="active === 'mylist'" id="mylist">
              <i class="bx bxs-bookmark"></i> | Mi lista
            </vs-navbar-item>
            <hr>
            <vs-navbar-item @click="logOff">
              <i class="bx bx-log-out-circle"></i> {{ $t("navbar.log_out") }}
            </vs-navbar-item>
          </template>
        </vs-navbar-group>
        <!-- <vs-tooltip bottom v-if="isLoggedIn">
          <vs-button icon @click="logout"><i class="bx bx-log-out-circle"></i></vs-button>
          <template #tooltip>Cerrar sesión</template>
        </vs-tooltip> -->
      </template>
    </vs-navbar>

    <vs-dialog width="500px" prevent-close not-center overflow-hidden v-model="popup.search.active">
      <template #header>
        <h4 style="margin-bottom: 0; margin-top: 10px;">Buscar...</h4>
      </template>
      <div class="con-content">
        <vs-row>
          <vs-col w="8">
            <vs-input v-model="popup.search.bar" placeholder="Buscar" @keyup.enter="searchNow"></vs-input>
          </vs-col>
        </vs-row>
      </div>
      <template #footer>
        <div class="con-footer" style="float: right;">
          <vs-button @click="searchNow" transparent style="color: #fff">
            Buscar
          </vs-button>
        </div>
      </template>
    </vs-dialog>

    <vs-dialog width="500px" prevent-close not-center overflow-hidden v-model="popup.login.active">
      <template #header>
        <h2 style="margin-bottom: 0; margin-top: 10px;">Iniciar sesión</h2>
      </template>
      <div class="con-content">
        <vs-input v-model="popup.login.email" placeholder="Correo electrónico">
          <template #icon>@</template>
        </vs-input>
        <br>
        <vs-input type="password" v-model="popup.login.password" placeholder="Contraseña">
          <template #icon><i class='bx bxs-lock'></i></template>
        </vs-input>
      </div>

      <template #footer>
        <div class="footer-dialog">
          <vs-button block size="large" @click="loginSubmit">Iniciar sesión</vs-button>
          <small class="new">
            ¿Nuevo aquí? <a @click="popup.register.active = true" class="animacion-enlace">Crear nueva cuenta</a>
          </small>
        </div>
      </template>
    </vs-dialog>

    <!-- Register -->
    <vs-dialog width="500px" prevent-close not-center overflow-hidden v-model="popup.register.active">
      <template #header>
        <h2 style="margin-bottom: 0; margin-top: 10px;">
          Registrarse
        </h2>
      </template>

      <div class="con-content">
        <vs-input v-model="popup.register.email" placeholder="Correo electrónico">
          <template #icon>
            @
          </template>
        </vs-input>
        <br>
        <vs-input v-model="popup.register.username" placeholder="Usuario">
          <template #icon>
            <i class="bx bxs-edit"></i>
          </template>
        </vs-input>
        <br>
        <vs-input type="password" v-model="popup.register.password" placeholder="Contraseña">
          <template #icon>
            <i class='bx bxs-lock'></i>
          </template>
        </vs-input>
        <br>
        <vs-input type="password" v-model="popup.register.confirmPassword" placeholder="Repetir contraseña">
          <template #icon>
            <i class='bx bxs-lock'></i>
          </template>
        </vs-input>
        <br>
        <vs-checkbox v-model="popup.register.termsAndCondition">
          Acepto los <a class="animacion-enlace needs-space" href="/tos">Términos y Condiciones</a> del servicio.
        </vs-checkbox>
      </div>

      <template #footer>
        <div class="footer-dialog">
          <form @submit.prevent="onSubmit">
            <vue-recaptcha
                sitekey="6LcmqpQcAAAAAAzBzY1Vn0RO7tY7JdPRXfC1oCiN"
                :loadRecaptchaScript="true"
                ref="invisibleRecaptcha"
                @verify="onVerify"
                @expired="onExpired"
                size="invisible">
            </vue-recaptcha>
            <vs-button block size="large" type="submit">
              Registrarme
            </vs-button>
          </form>
          <!-- <small class="new">
            ¿Nuevo aquí? <a href="#" class="animacion-enlace">Crear nueva cuenta</a>
          </small> -->
        </div>
      </template>
    </vs-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'; // <-- Magia nativa de Vuex
import api from '@/services/api';

import VidentiIcon from "./VidentiIcon";
import VueRecaptcha from 'vue-recaptcha';

export default {
  name: "NavBar",
  components: {VidentiIcon, VueRecaptcha},
  props: {
    hide: { type: Boolean, default: false },
    active: String,
    transparent: { type: Boolean, default: false },
    transparentOnTop: { type: Boolean, default: false },
    backButton: { type: Boolean, default: false },
    scrollPadding: { type: Boolean, default: true },
    searchButton: { type: Boolean, default: true }
  },

  data:() => ({
    popup: {
      search: { active: false, bar: "", type: "1" },
      login: { active: false, email: "", password: "" },
      register: { active: false, username: "", email: "", confirmPassword: "", password: "" }
    }
  }),

  computed: {
    // 1. Traemos todo limpiecito desde Vuex
    ...mapState('auth', ['isLoggedIn', 'username', 'avatarURL']),

    // 2. Arreglo para la prop 'active' mutada
    internalActive: {
      get() { return this.active; },
      set(val) { this.$emit('update:active', val); }
    }
  },

  methods: {
    // Mapeamos las acciones
    ...mapActions('auth', ['loginSuccess', 'logout']),

    logOff() {
      this.logout();
      location.reload();
    },

    async loginSubmit() {
      if (this.popup.login.email === '') {
        return this.$vs.notification({ progress: 'auto', color: "danger", duration: "5000", title: 'Falta correo', text: `Por favor ingresa tu correo electrónico.`})
      } else if (this.popup.login.password === '') {
        return this.$vs.notification({ progress: 'auto', color: "danger", duration: "5000", title: 'Falta contraseña', text: `Por favor ingresa tu contraseña.` });
      }

      try {
        const resLogin = await api.post('/auth/login', {
          email: this.popup.login.email,
          password: this.popup.login.password
        });

        // Ejecutamos la acción de Vuex
        this.loginSuccess(resLogin.data);

        this.$vs.notification({
          progress: 'auto', color: "success", duration: "4000",
          title: 'Ingresado 🎉',
          text: 'Bienvenido de vuelta, ' + this.username,
        });

        this.popup.login.active = false;

      } catch (err) {
        const errorMsg = err.response?.data?.error || 'No se pudo contactar con el servidor';

        this.$vs.notification({
          progress: 'auto', color: "danger", duration: "5000",
          title: 'Error de inicio de sesión',
          text: errorMsg
        });
      }
    },

    onSubmit: function () { this.$refs.invisibleRecaptcha.execute() },
    onVerify: function (response) { this.registerSubmit(response); },
    onExpired: function () { console.log('Expired') },

    openSearchPopup() {
      this.popup.search.active = true;
      setTimeout(function () { document.querySelector('div[placeholder="Buscar"] > .vs-input-content > input').focus() }, 100);
    },
    searchNow() {
      this.popup.search.active = false;
      if (this.popup.search.bar === '' || this.popup.search.bar.length < 2) {
        this.$vs.notification({
          progress: 'auto',
          color: "danger",
          duration: "5000",
          title: 'Búsqueda inválida',
          text: `Debes colocar algo qué buscar.`
        })
      } else {
        if (window.location.pathname.split("/")[1] === 'search') {
          window.location.replace(window.location.origin + "/search?q=" + this.popup.search.bar + "&t=" + this.popup.search.type);
        } else {
          this.$router.replace({ name: 'buscar', query: { q: this.popup.search.bar } })
        }
        this.popup.search.bar = '';
      }
      if (document.body.style.overflow) {
        document.body.style.overflow = "unset"
      }
    },
    async registerSubmit(captchaRecieved) {
      // 1. Validaciones del frontend (Intactas, están perfectas)
      if (this.popup.register.termsAndCondition === false) {
        return this.$vs.notification({
          progress: 'auto',
          color: "danger",
          duration: "5000",
          title: 'Requieres aceptar',
          text: `Debes aceptar los Términos y Condiciones del servicio para poder registrarte.`
        })
      }
      if (this.popup.register.password !== this.popup.register.confirmPassword) {
        return this.$vs.notification({
          progress: 'auto',
          color: "danger",
          duration: "5000",
          title: 'Contraseñas no coinciden',
          text: `Digita correctamente la misma contraseña en ambos campos.`
        })
      } else if (this.popup.register.confirmPassword === '') {
        return this.$vs.notification({
          progress: 'auto',
          color: "danger",
          duration: "5000",
          title: 'Indica tu contraseña',
          text: `No te estoy diciendo que esté mal tu contraseña... Si no que ni has digitado una.`
        })
      }

      // 2. Petición a la nueva API
      try {
        // Usamos tu instancia global 'api' enviando JSON puro (como espera el struct de Fiber)
        const resRegister = await api.post('/auth/register', {
          username: this.popup.register.username,
          email: this.popup.register.email,
          password: this.popup.register.password,
          recaptcha_token: captchaRecieved // Emparejado con el JSON tag de Go
        });

        // 3. Éxito (Status 200 OK)
        this.$vs.notification({
          progress: 'auto',
          color: "success",
          duration: "5000",
          title: 'Registrado 🎉',
          text: resRegister.data.message
        });

        // Cerramos el modal
        this.popup.register.active = false;

        // (Opcional pero recomendado) Limpiamos el formulario por si quiere volver a abrirlo
        this.popup.register.username = "";
        this.popup.register.email = "";
        this.popup.register.password = "";
        this.popup.register.confirmPassword = "";
        this.popup.register.termsAndCondition = false;

      } catch (err) {
        // 4. Captura de errores (Go Fiber responde con 400, 403, 409, etc.)
        // Leemos la llave "error" que mandas desde los handlers de Go
        const errorMsg = err.response?.data?.error || 'Ocurrió un error inesperado al registrarte.';

        this.$vs.notification({
          progress: 'auto',
          color: "danger",
          duration: "5000",
          title: 'No se pudo registrar',
          text: errorMsg
        });
      }
    }
  }
}
</script>

<style lang="scss">
.vs-navbar-content {
  &.transparent-bg {
    background: transparent;
    color: rgba(var(--vs-text), 1) !important;
    .videntiIcon { color: white; }

    &.transparent-on-top.paddingScroll.paddingScrollActive  {
      background: whitesmoke !important;
      color: rgb(10,11,14) !important;
      .videntiIcon { color: black; }
    }
  }
  background: whitesmoke;
  color: rgb(10,11,14) !important;
  .videntiIcon { color: black; }
  position: fixed !important;
}
</style>
